import { Config, Network } from './types';

import arbitrum from './arbitrum';
import arbitrumSepolia from './arbitrum-sepolia';
import avalanche from './avalanche';
import base from './base';
import goerli from './goerli';
import giwaSepolia from './giwa-sepolia';
import gnosisChain from './gnosis-chain';
import mainnet from './mainnet';
import optimism from './optimism';
import polygon from './polygon';
import sepolia from './sepolia';
import zkevm from './zkevm';
import fraxtal from './fraxtal';
import mode from './mode';

const config: Record<Network | number, Config> = {
  [Network.MAINNET]: mainnet,
  [Network.GOERLI]: goerli,
  [Network.POLYGON]: polygon,
  [Network.ARBITRUM]: arbitrum,
  [Network.ARBITRUM_SEPOLIA]: arbitrumSepolia,
  [Network.GIWA_SEPOLIA]: giwaSepolia,
  [Network.OPTIMISM]: optimism,
  [Network.GNOSIS]: gnosisChain,
  [Network.ZKEVM]: zkevm,
  [Network.AVALANCHE]: avalanche,
  [Network.SEPOLIA]: sepolia,
  [Network.BASE]: base,
  [Network.FRAXTAL]: fraxtal,
  [Network.MODE]: mode,
};

export default config;
